module.exports = __webpack_public_path__ + "img/ExhibitNormalRight.2024b3aa.png";